<template>
  <div class="notification-card" v-if="notificationVisible" @click="openNotification">
    <div class="message-container">
      <div class="notification-message">
        {{ notificationMessage }}
      </div>
    </div>
    <div class="notification-controls">
      <DxButton icon="close" styling-mode="text" @click="headerStore.hideNotification(notificationId)" />
    </div>
  </div>
</template>

<script setup>
  import DxButton from "devextreme-vue/button";
  import { useRouter } from "vue-router";
  import { useHeaderStore } from "@/stores/headerStore.js";

  const headerStore = useHeaderStore()
  const router = useRouter()
  const props = defineProps(['notificationId', 'notificationType', 'notificationMessage', 'notificationVisible', 'notificationContent'])

  const openNotification = () => {
    if (props.notificationType === "userDownloads" && props.notificationContent?.cabinet_id) {
      router.push({
        name: 'cabinetDownload',
        params: { cabinetId: props.notificationContent.cabinet_id }
      })
    }
  }
</script>

<style scoped lang="scss">
  .notification-card~.notification-card {
    border-top: solid $gray-darkest 1px;
  }

  .notification-card {
    width: 400px;
    display: flex;
    flex-direction: row;
    gap: 10px;

    .notification-icon {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    .message-container {
      flex-grow: 1;
      display: flex;
      align-items: center;
      padding: 8px 10px;

      .notification-message {
        white-space: normal;
        word-wrap: normal;
      }
    }

    .notification-controls {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
    }
  }

  .notification-card:hover {
    background-color: $gray-lighter;
    cursor: pointer;
  }
</style>
